import axios from 'axios';
import { defaultFeatureFlags, FeatureFlags } from './featureFlags';

const featureFlagsService = {
  get: async (): Promise<FeatureFlags> => {
    try {
      const response = await axios.get('/api/featureFlags');
      const data = response?.data ?? {};
      return {
        parkingEnabled: Boolean(
          data.parkingEnabled ?? data.ParkingEnabled ?? false
        ),
        htmlAppletsEnabled: Boolean(
          data.htmlAppletsEnabled ?? data.HtmlAppletsEnabled ?? false
        ),
        multiTenancyEnabled: Boolean(
          data.multiTenancyEnabled ?? data.MultiTenancyEnabled ?? false
        ),
      };
    } catch {
      return { ...defaultFeatureFlags };
    }
  },
};

export default featureFlagsService;
